
import './App.css';
import React from 'react'
import { BodyContainer, FooterContainer, Header } from './containers';



const App = () => {
  return (

    <div className='App'>
      <div className='navbar'>
        <Header />
      </div>
      <div className='header'>
        <BodyContainer />
      </div>

      <div className='footer'>
        <FooterContainer />
      </div>
    </div>


  )
}

export default App